import { createBreakpoint } from 'react-use';

export const useBreakpoint = createBreakpoint({
    desktop: 600,
    mobile: 0,
});
